// Third-party
import Grid from '@mui/material/Grid2';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

// Hooks
import { Stack } from '@mui/material';
import { MemoizedBaseAvatar } from '@mgm/common/components/base';
import { useAppSelector } from '../../../../hooks/useAppStore';

// Redux-toolkit
import { getSelectedMember } from '../../../../store/sheets/selectors';

// Components

const RootStyle = styled(Card)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(2, 2, 2, 3),
}));

const TimesheetsMemberHeader = () => {
  const selectedMember = useAppSelector(getSelectedMember);

  return (
    <Grid container spacing={2} columns={12}>
      <Grid
        size={{
          xs: 12, sm: 12, md: 12, lg: 12,
        }}
      >
        <RootStyle>
          <div>
            <Typography variant="h4">{selectedMember.personnel.name}</Typography>
            <Stack direction="row" spacing={2}>
              <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>
                {selectedMember.personnel.position}
              </Typography>
              <Typography pt={0.2} variant="subtitle2" color="primary">
                {selectedMember.personnel.department}
              </Typography>
            </Stack>
          </div>
          <Stack alignItems="center" justifyContent="center" sx={{ position: 'relative' }}>
            <MemoizedBaseAvatar
              avatarName={selectedMember.personnel.name}
              avatarFile={selectedMember.personnel.avatarFile}
              size={{
                width: 65,
                height: 65,
              }}
              fontSize={30}
              sx={{
                marginLeft: '12px',
                marginRight: '16px',
              }}
            />
          </Stack>
        </RootStyle>
      </Grid>
    </Grid>
  );
};

export {
  TimesheetsMemberHeader,
};
